// frontend/src/components/Approval/GIFControls.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import './GIFControls.css';

export default function GIFControls({ gifMetadata, onChange, onRemove, isRemoving = false }) {
  const { t } = useTranslation();

  return (
    <div className="gif-controls-panel">
      <div className="gif-control-section">
        <label className="gif-control-label">{t('upload:gif.sizeLabel')}</label>
        <input
          type="range"
          min="50"
          max="500"
          value={gifMetadata.size.width}
          onChange={(e) => {
            const size = parseInt(e.target.value);
            onChange({
              ...gifMetadata,
              size: { width: size, height: size }
            });
          }}
          className="gif-slider"
          disabled={isRemoving}
        />
        <span className="gif-slider-value">{gifMetadata.size.width}px</span>
      </div>

      <div className="gif-control-section">
        <label className="gif-control-label">{t('upload:gif.opacityLabel')}</label>
        <input
          type="range"
          min="30"
          max="100"
          value={gifMetadata.opacity * 100}
          onChange={(e) => {
            onChange({
              ...gifMetadata,
              opacity: parseInt(e.target.value) / 100
            });
          }}
          className="gif-slider"
          disabled={isRemoving}
        />
        <span className="gif-slider-value">{Math.round(gifMetadata.opacity * 100)}%</span>
      </div>

      <button
        onClick={onRemove}
        className="gif-remove-btn"
        disabled={isRemoving}
      >
        <Trash2 size={16} />
        {isRemoving ? (t('upload:gif.removing') || 'Removing...') : t('upload:gif.removeButton')}
      </button>
    </div>
  );
}

GIFControls.propTypes = {
  gifMetadata: PropTypes.shape({
    giphy_id: PropTypes.string.isRequired,
    giphy_url: PropTypes.string.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired
    }).isRequired,
    size: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired,
    opacity: PropTypes.number.isRequired,
    layer_order: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  isRemoving: PropTypes.bool
};
